import styled, { css } from "styled-components";
import { colors } from "constants/colors";
import { FontSize, fontSize } from "constants/fontSize";
import { newColors } from "constants/newColors";

export type StatusButtonProps = {
  isActive: boolean;
  size?: FontSize;
  outlined?: boolean;
};

export const StyledStatusButton = styled.button<StatusButtonProps>`
  border-radius: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;

  font-size: ${({ size }) => {
    return size ? fontSize[size] : "inherit";
  }};
  padding: 2px 18px;

  ${({ outlined }) => {
    return outlined
      ? css`
          border: solid 1px ${newColors.border};
        `
      : css`
          border: 0px;
        `;
  }}

  :hover {
    cursor: pointer;
    opacity: 0.8;
  }

  :disabled {
    cursor: default;
    opacity: 0.3;
  }

  ${({ isActive }) => {
    return isActive
      ? css`
          background-color: ${colors.priamry};
          color: ${colors.white};
          border: 0px;
        `
      : css`
          background-color: transparent;
          color: ${colors.text};
        `;
  }}
`;
